"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    accessible: _propTypes.bool,
    isMobile: _propTypes.bool,
    disableSearch: _propTypes.bool,
    loyaltyId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    loyaltyTier: (0, _propTypes.oneOf)(_constant2.MEMBER_TYPES),
    placeholder: _propTypes.string,
    onClickSearch: _propTypes.func,
    errorMessage: _propTypes.string,
    theme: _propTypes.string,
    initialValue: _propTypes.string,
    translation: (0, _propTypes.shape)({
      invalidEmailMessage: _propTypes.string,
      bigMemberId: _propTypes.string,
      formTitle: _propTypes.string,
      formSubTitle: _propTypes.string,
      search: _propTypes.string,
      earnBigPointsGuest: _propTypes.string,
      earnBigPoints: _propTypes.string,
      searchSubtitle: _propTypes.string,
      earnUpTo: _propTypes.string,
      points: _propTypes.string
    }),
    newVersion: _propTypes.bool,
    bigLoyaltyAlt: _propTypes.string,
    defaultToggle: _propTypes.bool,
    isLoading: _propTypes.bool,
    // showEarnUpTo: bool,
    totalPoints: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    // loadingOnly: bool,
    environment: _propTypes.string,
    apiKey: _propTypes.string,
    clientId: _propTypes.string,
    firstName: _propTypes.string,
    lastName: _propTypes.string,
    dateOfBirth: _propTypes.string,
    hasChanges: _propTypes.bool,
    onSubmit: _propTypes.func,
    handleField: _propTypes.func,
    isLoggedInUser: _propTypes.bool
  },
  DefaultProps: {
    accessible: true,
    isMobile: false,
    disableSearch: false,
    placeholder: 'Email address (optional)',
    onClickSearch: function onClickSearch() {},
    theme: _constant.DEFAULT_THEME,
    initialValue: '',
    translation: {
      invalidEmailMessage: 'That’s an invalid email format',
      bigMemberId: 'BIG Member ID',
      formTitle: 'Earn BIG Points with this booking',
      formSubTitle: 'Enter the email that’s registered under the BIG Member account of this guest',
      search: 'Search',
      earnBigPointsGuest: 'Earn BIG Points for this guest',
      earnBigPoints: 'Earn BIG Points',
      searchSubtitle: 'Search the BIG Member ID using the email address registered to this guest',
      earnUpTo: 'Earn up to',
      points: 'points'
    },
    newVersion: false,
    bigLoyaltyAlt: '',
    defaultToggle: false,
    isLoading: false,
    // showEarnUpTo: false,
    totalPoints: '',
    // loadingOnly: false,
    environment: _constant2.DEFAULT_ENV,
    apiKey: '',
    clientId: '',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    hasChanges: false,
    onSubmit: function onSubmit() {},
    handleField: function handleField() {},
    isLoggedInUser: false
  }
};
exports.default = _default;